export default function (date) {
    if (!date) {
        return "";
    }
    return `Q${date.getMonth() / 3 + 1} ${date.getFullYear()}`;
};